export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/ed4a96e1-0392-408e-8dda-239cdea0b5dd-test/OtAutoBlock.js',
  domainScript: 'ed4a96e1-0392-408e-8dda-239cdea0b5dd-test',
};
